const factory = loggingClient.getLoggerFactory({
	name: 'authoring-homepage-ui',
	version: '1.2'
}, {
	logToConsole: true,
	testMode: false,
	enablePolling: false,
	consoleLevel: loggingClient.Level.INFO,
	ajaxLevel: loggingClient.Level.WARN
});

module.exports = factory('general')
module.exports.createLogger = (name) => { return factory(name); }



// WEBPACK FOOTER //
// ./app/common/logging.config.js